<template>
  <aside class="tree-navigator"
         :class="{'tree-navigator_closed': !isOpen, 'tree-navigator_sidebar': !sidebarOpen}">
    <div class="scroll-content">
      <header class="navigator-top">
        <router-link tag="h2"
                     :to="navigatorLink"
                     v-if="isOpen"
                     class="title title-big">
          {{$t('things.navigator')}} <br>
          {{$t('things.navigatorByProject')}}
        </router-link>
        <button @click="toggleNavigator"
                type="button">
          <navigator-icon :active="isOpen"></navigator-icon>
        </button>
      </header>
      <div class="sub-header" v-if="isOpen">
        <router-link tag="span"
                     class="sub-header_link"
                     :to="navigatorLink">
          <span>
            {{subheaderText}}
          </span>
          <slot class="icon"></slot>
        </router-link>
      </div>
      <div class="trees-container" v-if="isOpen">
        <vue-tree-list :default-expanded="false"
                       class="nav-body"
                       @click="clickInNode"
                       :model="tree"
                       v-for="(tree, i) of trees"
                       :key="`tree-${i}`"
        >
          <span class="icon icon-single" slot="leafNodeIcon">
          <leaf-icon></leaf-icon>
        </span>
          <span class="icon icon-group" slot="treeNodeIcon">
          <group-icon></group-icon>
        </span>
          <span class="icon icon-mother" slot="delNodeIcon">
          <mother-icon></mother-icon>
        </span>
        </vue-tree-list>
      </div>

      <div class="tags__block" v-if="isOpen" :class="{hide: !is_tags_active}">
        <div class="tags__block__header">
          <h3 class="tags__block__title">{{$t('things.sections.tags.tagsTitle')}}</h3>

          <div class="tags__block__toggler" @click="toggleTags"></div>
        </div>

        <div class="tags__search__wrap">
          <svg data-v-62c0311c="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z" fill="#29ABE2"></path></svg>

          <input type="text" v-model="search_tags" class="tags__search__input" placeholder="Поиск по тегу">
        </div>

        <div class="tags" v-if="filteredTags">
          <a class="tag" :class="{'active': active_tags.find(item => item.id == tag.id)}" v-for="tag in filteredTags" :key="tag.id" @click="toggleTag(tag)">{{ tag.name }}</a>
        </div>
      </div>

      <router-link tag="h2"
                   :to="navigatorLink"
                   class="title title-big title_opacity" v-if="!isOpen">
        {{$t('things.navigator')}}
      </router-link>

      <div class="tags__block__sidebar" v-if="!isOpen">
        <h3 class="tags__block__title">{{$t('things.sections.tags.tagsTitle')}}</h3>

        <div class="tags__block__toggler"></div>
      </div>
    </div>
  </aside>
</template>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import {VueTreeList, Tree, TreeNode} from 'vue-tree-list'
  import navigatorIcon from '../Svg/things/navigatorIcon'
  import groupIcon from '../Svg/projects/navigator/groupIcon'
  import leafIcon from '../Svg/projects/navigator/leafIcon'
  import motherIcon from '../Svg/projects/navigator/motherIcon'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {sidebarState} from "../../mixins/utils/sidebarState";
  import {navigatorMixin} from "../../mixins/utils/navigatorMixin";

  export default {
    name: 'allProjectsNavigator',
    props: {
      isOpen: {
        type: Boolean,
      },
      navigatorLink: {
        type: String,
      },
      subheaderText: {
        type: String,
      }
    },
    data() {
      return {
        is_tags_active: true,
        search_tags: '',
        active_tags: []
      }
    },
    mixins: [tokenAndRoute, sidebarState, navigatorMixin],
    components: {
      VueTreeList,
      navigatorIcon,
      // thingIcon,
      // navVirtual,
      groupIcon,
      leafIcon,
      motherIcon
    },
    computed: {
      ...mapState({
        thing: state => state.things.device,
        allThingsTags: state => state.things.allThingsTags,
        allRolesTags: state => state.roles.allRolesTags,
        activeRolesTags: state => state.roles.activeRolesTags
      }),
      ...mapGetters({
        treeNavigator: 'projects/navigatorTree',
        allProjectsNavigatorTree: 'projects/allProjectsNavigatorTree',
        owned: 'things/tree'
      }),
      ownedThings() {
        return new Tree(this.owned)
      },
      trees() {
        let trees = []
        for (let i = 0; i < this.allProjectsNavigatorTree.length; i++) {
          trees.push(new Tree([this.allProjectsNavigatorTree[i]]))
        }
        return trees
      },
      filteredTags() {
        let tags = [];

        if(this.$route.fullPath.startsWith('/things')) {
          tags = this.allThingsTags;
        } else if(this.$route.fullPath.startsWith('/roles')) {
          tags = this.allRolesTags;
        }

        if(tags) {
          if(this.search_tags != '') {
            return tags.filter(tag => {
              if(String(tag.name).toLowerCase().includes(this.search_tags.toLowerCase())) {
                return true
              }
            });
          } else {
            return tags;
          }
        }
      }
    },
    watch: {
      thing(val) {
       this.setActiveNode(this.thing.name);
      },
      ownedThings(val) {
        this.setActiveNode(this.thing.name)
      },
      activeRolesTags(val) {
        this.active_tags = val;
      }
    },
    methods: {
      ...mapMutations({
        setActiveSection: 'things/SET_ACTIVE_SECTION',
        setDevicesActiveTags: 'things/SET_ACTIVE_TAGS',
        setRolesActiveTags: 'roles/SET_ACTIVE_TAGS',
      }),
      toggleNavigator() {
        if (this.isOpen) {
          this.$emit('close')
        } else {
          this.$emit('open')
        }
      },
      clickInNode(node) {
        this.$emit('clickInNode', node)
      },
      toggleTags(e) {
        e.target.parentElement.parentElement.scrollTop = 0;
        this.is_tags_active = !this.is_tags_active;
      },
      toggleTag(tag) {
        let active_tags = this.active_tags;

        let active_tags_id = [];

        for (let i = 0; i < active_tags.length; i++) {
          active_tags_id.push(active_tags[i].id);
        }

        if(active_tags_id.indexOf(tag.id) != -1) {
          active_tags.splice(active_tags_id.indexOf(tag.id), 1);
        } else {
          active_tags.push(tag);
        }

        this.active_tags = active_tags;

        if(this.$route.fullPath.startsWith('/things')) {
          this.setDevicesActiveTags(active_tags);
        } else if(this.$route.fullPath.startsWith('/roles')) {
          this.setRolesActiveTags(active_tags);
        }
      },
      // setActiveNode() {
      //   let name = this.thing.name;
      //   setTimeout( () => {
      //     let nodes = document.querySelectorAll('.vtl-node-main');
      //     nodes.forEach(item => {
      //       item.classList.remove('active-icon_node')
      //     });
      //
      //     for (let i = 0; i < nodes.length; i++) {
      //       let item = nodes[i];
      //       let contentItem = item.querySelector('.vtl-node-content');
      //       let content = contentItem.innerHTML.trim();
      //       let hint = document.querySelector('.btn-hint-navigator');
      //       let maxWordLength = 20;
      //
      //       if (window.matchMedia('(max-width: 1500px)').matches) {
      //         maxWordLength = 12
      //       };
      //
      //       if (window.matchMedia('(max-width: 1370px)').matches) {
      //         maxWordLength = 10
      //       };
      //
      //       function mouseEnter(text) {
      //         return function(e) {
      //           e = e || window.event;
      //
      //           let x = e.clientX;
      //           let y = e.clientY;
      //
      //           hint.style.top = `${y + 25}px`;
      //           hint.style.left = `${x}px`;
      //           hint.style.display = 'block';
      //           hint.innerHTML = text
      //         }
      //       };
      //
      //       function mouseLeave() {
      //         hint.style.display = 'none';
      //       };
      //
      //       //подсвечиваем активный
      //       if (content === name) {
      //         item.classList.add('active-icon_node');
      //       };
      //
      //
      //
      //       //ищем длинные и режем их
      //       if (content.length > maxWordLength) {
      //
      //         let checkHint = contentItem.classList.contains('hint-cont');
      //         if (!checkHint) {
      //           contentItem.addEventListener('mouseenter', mouseEnter(content));
      //           contentItem.addEventListener('mouseleave', mouseLeave);
      //           contentItem.classList.add('hint-cont');
      //
      //           content = content.slice(0, maxWordLength) + '...';
      //           contentItem.innerHTML = content;
      //         }
      //
      //       }
      //
      //     }
      //   }, 200)
      //
      // }
    },

    mounted() {
      this.setActiveNode(this.thing.name)
      let section = localStorage.getItem('thing-section');
      if (!!section) {
        this.setActiveSection(section)
      }
    }

  }
</script>

<!--<style lang="scss">-->
<!--  .nav-body {-->
<!--    position: relative;-->
<!--    top: 0;-->
<!--    left: 0;-->
<!--    height: 50% !important;-->
<!--    overflow-y: scroll!important;-->
<!--  }-->
<!--</style>-->

<style lang="scss" scoped>
  .trees-container {
    position: absolute;
    min-width: 205px;
    left: 30px;
    top: 162px;
    height: 35%;
    overflow: scroll;
    @include scrollbal(2px);
  }
  .tree-navigator {
    .nav-body {
      position: relative;
      top: 0;
      left: 0;

    }
  }

  .sub-header {
    font-family: MSB, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 44px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    color: $blue;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid $grey;
    margin-top: -20px;

    .sub-header_link {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 10px;
    }

    .icon {
      max-width: 24px;
    }
  }

  /* Tags */

.tags__block {
  background-color: $lightGrey;
  position: absolute;
  top: 59%;
  bottom: 1%;
  left: 30px;
  right: 0;
  height: 40%;
  padding-right: 28px;
  overflow-y: scroll;
  transition: top 0.25s ease-in-out, height 0.25s ease-in-out;
  @include scrollbal(2px);

  @media screen and (max-width: 1500px) {
    left: 25px;
    padding-right: 23px;
  }

  &.hide {
    top: calc(99% - 80px);
    height: 80px;
    padding-right: 25px;
    overflow-y: hidden;
  }

  .tags__block__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    height: 60px;
    margin-bottom: 20px;
    padding-top: 20px;
    border-top: 1px solid #D7E3EA;

    .tags__block__title {
      font-family: MSB, Arial, sans-serif;
      font-size: 18px;
      color: rgba(0, 83, 127, 0.9);
      letter-spacing: 0.25px;
    }

    .tags__block__toggler {
      min-width: 30px;
      max-width: 30px;
      height: 30px;
      margin: 0 -2px 0 10px;
      background: url('../../assets/toggler.svg');
      background-repeat: no-repeat;
      background-size: auto;
      background-position: center;
      transition: opacity 0.25s ease-in-out;
      cursor: pointer;
    }
  }

  &.hide {
    .tags__block__header {
      .tags__block__toggler {
        opacity: 0.4;
      }
    }
  }

  .tags__search__wrap {
    position: relative;
    margin-bottom: 20px;

    svg {
      position: absolute;
      top: 50%;
      left: 20px;
      margin-top: -10px;
    }

    .tags__search__input {
      font-family: MM, Arial, sans-serif;
      font-size: 14px;
      color: #00527F;
      width: 100%;
      padding: 13px 15px 11px 60px;
      background: none;
      border: 1px solid rgba(0, 83, 127, 0.1);
      border-radius: 4px;
      outline: none;

      &::-webkit-input-placeholder {
        color: rgba(0, 83, 127, 0.5);
      }

      &::-moz-placeholder {
        color: rgba(0, 83, 127, 0.5);
      }

      &:-moz-placeholder {
        color: rgba(0, 83, 127, 0.5);
      }

      &:-ms-input-placeholder {
        color: rgba(0, 83, 127, 0.5);
      }
    }
  }

  .tags {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 -8px 8px 0;

    .tag {
      font-family: MR, Arial, sans-serif;
      font-size: 14px;
      color: #109cf1;
      margin: 0 8px 8px 0;
      padding: 5px 11px 3px;
      border: 0.5px solid #109cf1;
      border-radius: 6px;
      transition: all 0.25s ease-in-out;
      letter-spacing: 0.25px;
      cursor: pointer;

      &:hover,
      &.active {
        color: #fff;
        background: #109cf1;
        box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      }
    }
  }
}

.tags__block__sidebar {
  position: absolute;
  left: 20px;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  opacity: 0.4;
  transform: rotate(-90deg);
  transform-origin: top left;

  .tags__block__title {
    font-family: MSB, Arial, sans-serif;
    font-size: 14px;
    color: rgba(0, 83, 127, 0.9);
    margin-top: 1px;
    letter-spacing: 0.25px;
  }

  .tags__block__toggler {
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    margin-left: 15px;
    background: url('../../assets/toggler.svg');
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center;
  }
}
 /* .tree-navigator {
    max-width: 300px;
    width: 300px;
    height: calc(100vh - 90px);
    position: fixed;
    top: 90px;
    padding-top: 24px;
    left: 240px;
    border-right: 1px solid $grey;
    padding-left: 30px;
    padding-right: 30px;
    overflow: scroll;
    @include scrollbal(10px);

    @media screen and (max-width: 1500px) {
      max-width: 250px;
      padding-left: 25px;
      padding-right: 25px;
    }

    @media screen and (max-width: 1370px) {
      max-width: 200px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .nav-body {
    position: absolute;
    min-width: 234px;
    left: 30px;
    top: 24px + 58px + 20px;

    @media screen and (max-width: 1500px) {
      min-width: 189px;
    }

    @media screen and (max-width: 1370px) {
      min-width: 139px;
    }
  }

  .tree-navigator_sidebar {
    left: 60px;
   // padding-left: 20px;
  }

  .tree-navigator_closed {
    max-width: 70px;
    padding: 30px 20px;


    .navigator-top {
      border: none;
    }
  }

  .navigator-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 24px;
    border-bottom: 1px solid $grey;
    margin-bottom: 20px;


  }

  .title {
    font-family: $msb;
    font-size: 18px!important;
    letter-spacing: .25px;
    color: $darkBlue;


    @media screen and (max-width: 1370px) {
      font-size: 14px!important;
    }
  }

  .title_opacity {
    opacity: .4;
    transform: rotate(-90deg) translateX(-70px);
    transform-origin: 0 0%;

  }

  .title-big {
    cursor: pointer;

  }*/
</style>
